// Add your custom JS here.
(function () {
    var header = document.querySelector("header.header-site");
    var isScrolled = false;

    window.addEventListener("scroll", function () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (!isScrolled && scrollTop > 50) {
            header.classList.add("scrolled");
            isScrolled = true;
        } else if (isScrolled && scrollTop < 10) {
            header.classList.remove("scrolled");
            isScrolled = false;
        }
    });
})();

jQuery(document).ready(function ($) { });

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)",
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

document.fonts.ready.then(function () {
    document.body.classList.add("font-loaded");
});

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;
    jQuery(document).on("sf:ajaxfinish", function () {
        AOS.refreshHard();
    });

    var target = document.querySelector("#block-search-and-filter");
    if (target) {
        var resizeObserver = new ResizeObserver(function () {
            AOS.refreshHard();
        });
        resizeObserver.observe(target);
    }
});

//  Smooth scroll for hash links
document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth < 992;
    const offset = isMobile ? 180 : 230;

    function scrollToHash(hash) {
        const el = document.querySelector(hash);
        if (el) {
            setTimeout(() => {
                window.scrollTo({
                    top: el.getBoundingClientRect().top + window.pageYOffset - offset,
                    behavior: "smooth",
                });
            }, 50);
        }
    }

    if (window.location.hash) {
        scrollToHash(window.location.hash);
    }

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener("click", function (e) {
            const hash = this.getAttribute("href");
            if (hash.length > 1) {
                e.preventDefault();
                history.pushState(null, null, hash);
                scrollToHash(hash);
            }
        });
    });
});

// Header Buttons & Search — move into Mega Menu on mobile (<= 1100px)
document.addEventListener("DOMContentLoaded", function () {
    var BREAKPOINT = 1100;
    var headerButtons = document.querySelector(".header-buttons");
    var mobileSearch = document.getElementById("mobile-search");
    var searchButton = document.getElementById("header-search-toggle");
    var megaMenu = document.querySelector("#mega-menu-primary");
    var contentMenuLists = document.querySelector(".content-menu-lists");

    if (!headerButtons || !megaMenu || !mobileSearch || !contentMenuLists) return;

    // Wrapper <li> elements for mega menu structure
    var liButtons = document.createElement("li");
    liButtons.className = "mega-menu-item mega-menu-item-type-custom mega-menu-flyout menu-item-header-buttons";

    var liSearch = document.createElement("li");
    liSearch.className = "mega-menu-item mega-menu-item-type-custom mega-menu-flyout menu-item-mobile-search";

    var isInMegaMenu = false;

    function syncLayout() {
        if (window.innerWidth <= BREAKPOINT && !isInMegaMenu) {
            liSearch.appendChild(mobileSearch);
            liButtons.appendChild(headerButtons);
            megaMenu.appendChild(liSearch);
            megaMenu.appendChild(liButtons);
            isInMegaMenu = true;
        } else if (window.innerWidth > BREAKPOINT && isInMegaMenu) {
            // Insert before the search icon to preserve original order:
            // [menu] [header-buttons] [search-button] [mobile-search]
            contentMenuLists.insertBefore(headerButtons, searchButton);
            contentMenuLists.appendChild(mobileSearch);
            if (liButtons.parentNode) liButtons.parentNode.removeChild(liButtons);
            if (liSearch.parentNode) liSearch.parentNode.removeChild(liSearch);
            isInMegaMenu = false;
        }
    }

    syncLayout();
    window.addEventListener("resize", syncLayout);
});

// Header Search Toggle
document.addEventListener("DOMContentLoaded", function () {
    const searchToggle = document.getElementById("header-search-toggle");
    const searchPanel = document.getElementById("header-search-panel");
    const searchClose = document.getElementById("header-search-close");
    const searchInput = searchPanel
        ? searchPanel.querySelector(".header-search-input")
        : null;

    if (searchToggle && searchPanel) {
        searchToggle.addEventListener("click", function () {
            const isActive = searchPanel.classList.toggle("is-active");
            searchPanel.setAttribute("aria-hidden", !isActive);
            if (isActive && searchInput) {
                searchInput.focus();
            }
        });

        if (searchClose) {
            searchClose.addEventListener("click", function () {
                searchPanel.classList.remove("is-active");
                searchPanel.setAttribute("aria-hidden", "true");
            });
        }

        // Close on Escape key
        document.addEventListener("keydown", function (e) {
            if (
                e.key === "Escape" &&
                searchPanel.classList.contains("is-active")
            ) {
                searchPanel.classList.remove("is-active");
                searchPanel.setAttribute("aria-hidden", "true");
                searchToggle.focus();
            }
        });
    }
});

// Lenis Smooth Scroll
document.addEventListener("DOMContentLoaded", function () {
    // Initialize Lenis
    const lenis = new Lenis({
        autoRaf: true,
    });

    // Listen for the scroll event and log the event data
    lenis.on("scroll", (e) => {
        console.log(e);
    });
});

// hero cards
jQuery(document).ready(function ($) {
    $(".hero-banner-cards__card video").each(function () {
        this.muted = true;
        this.loop = true;
        this.playsInline = true;
        $(this).attr("muted", "muted");
        $(this).attr("loop", "loop");
        $(this).attr("playsinline", "playsinline");
    });

    $(".hero-banner-cards__card").hover(
        function () {
            var $video = $(this).find("video");
            if ($video.length) {
                var videoEl = $video.get(0);
                videoEl.muted = true;
                videoEl.loop = true;
                videoEl.playsInline = true;

                var playPromise = videoEl.play();
                if (playPromise !== undefined) {
                    playPromise
                        .then(function () { })
                        .catch(function (error) {
                            console.log("Hover video play failed:", error);
                        });
                }
            }
        },
        function () {
            var $video = $(this).find("video");
            if ($video.length) {
                var videoEl = $video.get(0);
                videoEl.pause();
            }
        },
    );
});

// Video embed scroll fix — remove overlay on click to allow interaction
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('figure.is-type-video').forEach(function (figure) {
        figure.addEventListener('click', function () {
            this.classList.add('is-active');
        });
    });

    document.addEventListener('click', function (e) {
        if (!e.target.closest('figure.is-type-video')) {
            document.querySelectorAll('figure.is-type-video.is-active').forEach(function (fig) {
                fig.classList.remove('is-active');
            });
        }
    });
});

// Match max width of split-section images dynamically
document.addEventListener("DOMContentLoaded", function () {
    const images = document.querySelectorAll('.split-section__image-wrapper--overflow .split-section__image');
    if (images.length === 0) return;

    let maxWidth = 0;

    function calculateMaxWidth() {
        images.forEach(img => {
            const w = parseFloat(img.getAttribute('width')) || img.naturalWidth;
            const h = parseFloat(img.getAttribute('height')) || img.naturalHeight;

            if (w && h) {
                const aspectRatio = w / h;
                const calculatedWidth = 537 * aspectRatio; // Target height is 537px
                if (calculatedWidth > maxWidth) {
                    maxWidth = calculatedWidth;
                }
            }
        });

        if (maxWidth > 0) {
            document.documentElement.style.setProperty('--max-split-image-width', maxWidth + 'px');
        }
    }

    // Try calculation immediately using HTML attributes
    calculateMaxWidth();

    // Re-calculate on window load just in case attributes were missing
    window.addEventListener('load', calculateMaxWidth);
});


// add class section bg
document.querySelectorAll('section').forEach(section => {
    const styles = getComputedStyle(section);
    let bg = styles.backgroundColor;

    if (
        bg &&
        bg !== 'rgba(0, 0, 0, 0)' &&
        bg !== 'transparent'
    ) {

        const match = bg.match(/\d+/g);

        if (match) {
            const hex = match
                .slice(0, 3)
                .map(v => Number(v).toString(16).padStart(2, '0'))
                .join('');
            section.classList.add(`bg-${hex}`);
        }
    }
});